module.exports = __webpack_public_path__ + "img/balkon1.ad4e99ca.png";